import React, { useEffect, useRef, useState } from 'react'
import { string, object, bool } from 'prop-types'
import { sendClickEventToInsights } from '../../../utils/insights'
import { EMPTY_OBJECT } from '../../../utils/constants'

/* eslint-disable-next-line max-len */
const SaveButton = ({ url, title, image, insights = EMPTY_OBJECT, gridView, analyticsCategory = '', id = '', customInitSelector = '', triggerStyle = 'inverse', triggerHierarchy = 'primary', rest = EMPTY_OBJECT }) => {
  const [showToastWindow, setShowToastWindow] = useState(false)
  const toastTimer = useRef(null)

  useEffect(() => () => window.clearTimeout(toastTimer.current), [])

  const onClickTracked = e => {
    e.stopPropagation()
    window.clearTimeout(toastTimer.current)
    setShowToastWindow(true)
    toastTimer.current = window.setTimeout(() => setShowToastWindow(false), 5000)

    if (window.AD && window.AD.isLoggedIn) {
      const statusUpdate = e.currentTarget.dataset.status === 'update'
      const label = statusUpdate ? 'update' : 'save'
      if (analyticsCategory) {
        sendClickEventToInsights(analyticsCategory, 'click', label, insights.value, '')
      } else {
        const isFrom = window.MyAD && window.MyAD.saveWithDropdown ? 'quick-save' : 'reg-save'
        const viewLabel = gridView ? 'grid' : 'list'
        sendClickEventToInsights(`${isFrom}_search_save-btn`, 'click', label, insights.value, viewLabel)
      }
    }
  }
  const containerClass = gridView && '.gridview__item'
  const triggerProps = {
    'trigger-style': triggerStyle,
    'trigger-hierarchy': triggerHierarchy
  }

  return (
    <hd-save-dropdown
      class={`aa-newbrand ${customInitSelector} ${showToastWindow ? 'save-dropdown--toast-visible' : ''}`.trim()}
      id={id}
      page-title={title}
      page-image={image}
      url={url}
      data-container={containerClass}
      onClick={onClickTracked}
      {...triggerProps}
      {...rest}
    />
  )
}

SaveButton.propTypes = {
  url: string.isRequired,
  title: string,
  image: string,
  insights: object.isRequired,
  gridView: bool,
  analyticsCategory: string,
  customInitSelector: string,
  triggerStyle: string,
  triggerHierarchy: string,
  id: string,
  rest: object
}

export default SaveButton
